import { Component, OnInit } from '@angular/core';
import { BottomSheet } from '../bottom.sheet';
import { ApiService } from '../api.service';
import { Router } from '@angular/router';
import { HandlerService } from '../handler.service';
import { AuthService } from '../auth.service';
import { MatBottomSheet } from '@angular/material/bottom-sheet';

@Component({
  selector: 'app-referrals-list',
  templateUrl: './referrals-list.component.html',
  styleUrls: ['./referrals-list.component.scss'],
})
export class ReferralsListComponent {

  constructor(
    public service: ApiService,
    public router: Router,
    public handler: HandlerService,
    public auth: AuthService,
    private bottomSheet: MatBottomSheet
  ) { }

  orgId:any = localStorage.getItem('organizationId');
  items: any;
  loader: boolean = true;
  search;
  orgObj: any;
  orgName;
  newOrgObject;
  ionViewWillEnter(){
    this.orgObj=JSON.parse(localStorage.getItem('capabilityOrg'));
    let obj=[];
     this.orgObj.map(res => {
      let x = this.auth.getOrgCapabilities( res.id, 'SP');
      let y = this.auth.getOrgCapabilities( res.id,'MNGRR')
      if(x==true || y==true)
     obj.push(res)
    }) 
    this.newOrgObject=obj;
     let orgs=this.newOrgObject.find(dat=>dat.id==this.orgId);
    if(orgs)
    this.orgName=orgs.name;
     else{
       this.orgName=this.newOrgObject[0].name;
       this.orgId=this.newOrgObject[0].id;
     }
   this.service.getReferralList(this.orgId).subscribe((res:any)=>{
    if (res) { 
      this.items = res;
    }else{
      this.loader = false;
      this.handler.res("No Referral List For you")
    }
    this.loader = false;
    }, err => {
      this.loader = false;
      this.handler.err(err)
   })
  }
  openBottomSheetOrg(): void {
    const dialogRef = this.bottomSheet.open(BottomSheet, {
      data: this.newOrgObject,
    });
    dialogRef.afterDismissed().subscribe((res) => {
      if(res){
      this.loader=true;
      this.orgName = res.name;
      this.service.getReferralList(res.id).subscribe((res1:any)=>{
        if (res1) {
          this.items = res1;
        }
        else{
          this.handler.res("No Referral List For you")
          this.items=[]
        }
        this.loader = false;
        }, err => {
          this.loader = false;
          this.handler.err(err)
       })
    }
     });
  }

ionViewWillLeave(){
  this.search = "";
}

}
